import React from "react";
import "./LandingPage.css";

function LandingPage() {
  return (
    <div className="landing-container">
      <header className="landing-header">
        <div className="logo-area">
          <div className="logo-icon">🦅</div>
          <div className="logo-text">
            <span className="logo-main">EvoManager</span>
            <span className="logo-sub">by Software Eagle</span>
          </div>
        </div>
        <nav className="landing-nav">
          <a href="#features">Recursos</a>
          <a href="#differentials">Diferenciais</a>
          <a href="#contact">Contato</a>
        </nav>
      </header>
      <section className="hero-section">
        <div className="hero-content">
          <h1>Gestão Completa, Integrada e Inteligente</h1>
          <p>O <b>EvoManager</b> é o ERP definitivo para empresas que buscam eficiência, controle e crescimento. Atende desde oficinas mecânicas, retíficas, construtoras, comércio e indústria, com módulos completos e integração total.</p>
          <a href="#contact" className="cta-btn">Solicite uma Demonstração</a>
        </div>
      </section>
      <section className="segmentos-section">
        <h2>Segmentos Atendidos</h2>
        <div className="segmentos-grid">
          <div className="segmento-card">
            <img className="card-img" src="https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/72x72/1f527.png" alt="Oficina" />
            <h3><span className="icon">🔧</span>Oficinas Mecânicas & Retíficas</h3>
            <ul>
              <li>Gestão de ordens de serviço</li>
              <li>Controle de peças, serviços e mão de obra</li>
              <li>Histórico de veículos e clientes</li>
            </ul>
          </div>
          <div className="segmento-card">
            <img className="card-img" src="https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/72x72/1f3d7.png" alt="Obras" />
            <h3><span className="icon">🏗️</span>Construtoras & Obras</h3>
            <ul>
              <li>Cadastro e planejamento de obras</li>
              <li>Controle de BDI, insumos, equipamentos e despesas</li>
              <li>Resumo diário, exigências e viabilização de obras</li>
            </ul>
          </div>
          <div className="segmento-card">
            <img className="card-img" src="https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/72x72/1f6d2.png" alt="Comércio" />
            <h3><span className="icon">🏪</span>Comércio & Indústria</h3>
            <ul>
              <li>Gestão de estoque, compras e vendas</li>
              <li>Cadastro de clientes, fornecedores e produtos</li>
              <li>Emissão de notas fiscais e relatórios gerenciais</li>
            </ul>
          </div>
        </div>
      </section>
      <section id="features" className="features-section">
        <h2>Principais Módulos e Recursos</h2>
        <div className="features-grid">
          <div className="feature-card">
            <img className="card-img" src="https://img.icons8.com/fluency/48/000000/money-transfer.png" alt="Comissões de Vendas" />
            <h3><span className="icon">💼</span>Controle de Comissões de Vendas</h3>
            <ul>
              <li>Comissão por venda, recebimento quitado ou ambos simultaneamente</li>
              <li>Qualquer pessoa cadastrada pode ser comissionada (vendedor, cliente, fornecedor, etc.)</li>
              <li>Tabelas de comissões por peças, serviços e por pessoa</li>
              <li>Várias tabelas de preços e condições específicas de comissionamento por produto</li>
              <li>Comissões geradas como conta corrente: créditos automáticos, pagamentos parciais, débitos e bonificações</li>
              <li>Bonificações por desempenho e créditos manuais, sem necessidade de venda</li>
              <li>Totalmente integrado ao controle financeiro</li>
            </ul>
          </div>
          <div className="feature-card">
            <img className="card-img" src="https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/72x72/1f9f3.png" alt="Estoque e Almoxarifado" />
            <h3><span className="icon">📦</span>Gestão de Estoque e Almoxarifado</h3>
            <ul>
              <li>Vários pontos de almoxarifado e controle de estoque por local</li>
              <li>Requisições por motivo: reposição, uso/consumo, manufatura ou serviços</li>
              <li>Cotações com múltiplos fornecedores e produtos</li>
              <li>Montagem automática do pedido de compras</li>
              <li>Monitoramento de mercadorias entregues e pendentes</li>
              <li>Validação automática do preço de custo na nota fiscal de entrada</li>
              <li>Pedidos de compras avulsas</li>
              <li>Análise inteligente do que e quando comprar, integrado a obras, ordens de serviço e cronogramas</li>
            </ul>
          </div>
          <div className="feature-card">
            <img className="card-img" src="https://img.icons8.com/fluency/48/000000/warehouse.png" alt="Multiempresas e Armazéns" />
            <h3><span className="icon">🏢</span>Multiempresas, Filiais & Armazéns Gerais</h3>
            <ul>
              <li>Gerencie múltiplas empresas, filiais em um único sistema</li>
              <li>Controle de estoque por empresas, centros de estocagem, lotes, notas fiscais e produtos</li>
              <li>Ideal para armazéns gerais ou empresas com operações descentralizadas e que mantêm estoques fora de seus estabelecimentos principais</li>
              <li>Gerencie também, a localização de produtos por empresa, ideal para distribuidoras de peças onde os produtos variam de prateleiras em cada filial</li>
            </ul>
          </div>
          <div className="feature-card">
            <img className="card-img" src="https://img.icons8.com/fluency/48/000000/invoice.png" alt="Fiscal" />
            <h3><span className="icon">🧾</span>Controle Fiscal Completo</h3>
            <ul>
              <li>Emissão de Notas Fiscais Eletrônicas (NF-e)</li>
              <li>Emissão de Conhecimento de Transporte Eletônico (CT-e)</li>
              <li>Nota Fiscal de Consumidor Final Eletrônica (NFC-e)</li>
              <li>Manifesto de Documentos Fiscais Eletrônicos (MDF-e)</li>
              <li>Emissão de Notas Fiscais de Serviços Eletrônicas (NFS-e)</li>
              <li>Integração direta com a SEFAZ sem API´s de terceiros</li>
              <li>Geração de arquivos de conciliação (Sintegra e SPED ICMS/IPI)</li>
              <li>Integração com vários provedores de NFS-e (Consulte antes)</li>
            </ul>
          </div>
          <div className="feature-card">
            <img className="card-img" src="https://img.icons8.com/fluency/48/000000/money-bag.png" alt="Financeiro" />
            <h3><span className="icon">💰</span>Financeiro Totalmente Integrado</h3>
            <ul>
              <li>Contas a receber e a pagar</li>
              <li>Plano de contas fácil de ser criado e mantido</li>
              <li>Oferecemos o inovador recurso de UNIDADES ADMINISTRATIVAS</li>
              <li>Controle de contas correntes e conciliação bancária eletrônica</li>
              <li>Emissão de boletos bancários (FEBRABAN, APIs: BB, Sicoob, Bradesco, Sicredi, Itaú)</li>
              <li>Todos os lançamentos financeiros podem ter N centros de custos, com rateios automáticos</li>
              <li>Controle de desconto de títulos (apenas bara boletos registrados)</li>
              <li>Emissão de Relatórios Demonstrativos de Resultados (DRE)</li>
              <li>DRE flexível e pode ser customizada pelo cliente, sem dificuldades.</li>
            </ul>
          </div>
          <div className="feature-card">
            <img className="card-img" src="https://img.icons8.com/fluency/48/000000/plan.png" alt="Obras" />
            <h3><span className="icon">📊</span>Gestão de Obras</h3>
            <ul>
              <li>Cadastro de obras, planejamento, formação de custos e resumo diário de obras</li>
              <li>BDI (Benefício e Despesas Indiretas) personalízavel por obra</li>
              <li>Controle de estoque por obra: insumos e materiais enviados para obras e o uso/consumo dos mesmos</li>
              <li>Controle de equipamentos utilizados nas obras</li>
              <li>Controle de despesas adicionais de uma obra integrado com as definições de viabilidade da obra</li>
              <li>Todos os controles financeiros das obras são integrados a centros de custos pré-definidos pelo usuário</li>
              <li>Através dos centros de custos, o controle de obras é integrado ao gerenciador financeiro do sistema</li>
            </ul>
          </div>
          <div className="feature-card">
            <img className="card-img" src="https://img.icons8.com/fluency/48/000000/conference-call.png" alt="Pessoal" />
            <h3><span className="icon">👥</span>Departamento Pessoal</h3>
            <ul>
              <li>Gestão de funcionários, dependentes e cargos</li>
              <li>Processamento de folha de pagamento</li>
              <li>Verbas parametrizáveis por funcionário/cargo</li>
              <li>Integração total com financeiro</li>
            </ul>
          </div>
          <div className="feature-card">
            <img className="card-img" src="https://img.icons8.com/fluency/48/000000/tractor.png" alt="Frota" />
            <h3><span className="icon">🚜</span>Frota e Equipamentos</h3>
            <ul>
              <li>Controle de máquinas, veículos e equipamentos</li>
              <li>Relatórios de manutenção, históricos e mensais</li>
              <li>Horas trabalhadas, análise de viabilidade e substituição</li>
              <li>Integração com CT-e e financeiro</li>
            </ul>
          </div>
          <div className="feature-card">
            <img className="card-img" src="https://img.icons8.com/fluency/48/000000/agreement.png" alt="Locação" />
            <h3><span className="icon">📄</span>Locação de Equipamentos</h3>
            <ul>
              <li>Gestão de contratos de locação</li>
              <li>Substituição e histórico de equipamentos locados</li>
              <li>Emissão de contratos e boletos integrados</li>
              <li>Controle de equipamentos próprios e de terceiros</li>
            </ul>
          </div>
        </div>
        <div className="features-extra">
          <div className="extra-card">
            <h4><span className="icon">🏦</span>Integrações Bancárias</h4>
            <img className="card-img" src="https://img.icons8.com/fluency/48/000000/bank-building.png" alt="Banco" />
            <p>Conciliação eletrônica, emissão e processamento de boletos, integração com principais bancos do Brasil.</p>
          </div>
          <div className="extra-card">
            <h4><span className="icon">📈</span>Relatórios Gerenciais</h4>
            <img className="card-img" src="https://img.icons8.com/fluency/48/000000/combo-chart.png" alt="Relatórios" />
            <p>Emissão de DRE, relatórios de centros de custo, obras, frota, locação e muito mais.</p>
          </div>
          <div className="extra-card">
            <h4><span className="icon">🏢</span>Centros de Custo & Unidades Administrativas</h4>
            <img className="card-img" src="https://img.icons8.com/fluency/48/000000/organization.png" alt="Centros de Custo" />
            <p>Subdivisão de custos, integração entre módulos e visão detalhada dos resultados.</p>
          </div>
        </div>
      </section>
      <section className="evo-benefits-section">
        <h2>Simplicidade, Segurança e Economia Real</h2>
        <div className="evo-benefits-grid">
          <div className="evo-benefit-card">
            <span className="icon">👌</span>
            <h4>Simplicidade de Uso</h4>
            <p>Interface intuitiva, fácil de aprender e usar. Treinamento rápido e suporte direto, sem complicações.</p>
          </div>
          <div className="evo-benefit-card">
            <span className="icon">🔧</span>
            <h4>Manutenção Descomplicada</h4>
            <p>Atualizações automáticas, sem necessidade de intervenção do usuário. Equipe técnica sempre disponível.</p>
          </div>
          <div className="evo-benefit-card">
            <span className="icon">💸</span>
            <h4>Custo Baixo e Transparente</h4>
            <p>Sem taxas por volume de dados, sem limites de documentos fiscais e sem cobranças extras por integrações.</p>
          </div>
          <div className="evo-benefit-card">
            <span className="icon">🔗</span>
            <h4>Independência de APIs de Terceiros</h4>
            <p>Não dependemos de APIs externas para funcionamento. Mais estabilidade, menos custos e total controle.</p>
          </div>
          <div className="evo-benefit-card">
            <span className="icon">🗄️</span>
            <h4>Infraestrutura Própria</h4>
            <p>Servidores próprios, backups automáticos em tempo real, diário e semanal. Dados sempre protegidos.</p>
          </div>
          <div className="evo-benefit-card">
            <span className="icon">🛡️</span>
            <h4>Segurança e LGPD</h4>
            <p>25 anos sem perda de dados. Especialistas em cyber segurança e LGPD, proteção máxima para sua empresa.</p>
          </div>
        </div>
        <div className="evo-benefits-summary">
          <p><b>Com o EvoManager, você tem controle total, economia real e tranquilidade para focar no crescimento do seu negócio.</b></p>
        </div>
      </section>
      <section id="differentials" className="differentials-section">
        <h2>Por que escolher o EvoManager?</h2>
        <ul>
          <li>Interface moderna, intuitiva e responsiva</li>
          <li>Automação de processos fiscais, financeiros e operacionais</li>
          <li>Integração total entre módulos e bancos</li>
          <li>Relatórios gerenciais completos e personalizáveis</li>
          <li>Segurança, confiabilidade e suporte especializado</li>
          <li>Flexibilidade para atender diferentes segmentos e portes de empresa</li>
        </ul>
      </section>
      <section id="contact" className="contact-section">
        <h2>Solicite uma Demonstração</h2>
        <form className="contact-form">
          <input type="text" placeholder="Seu nome" required />
          <input type="email" placeholder="Seu e-mail" required />
          <textarea placeholder="Mensagem" required></textarea>
          <button type="submit">Enviar</button>
        </form>
      </section>
      <footer className="landing-footer">
        <span>© 2025 Software Eagle Sistemas Integrados. Todos os direitos reservados.</span>
      </footer>
    </div>
  );
}

export default LandingPage;
